export default {
  methods: {
    goToSignupStep (name = 'SignUp', step = '') {
      this.$router.push({name, params: {step}})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/common.js